var _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 121,
    viewBox: "0 0 122 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_407_8802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6546 95.375C82.7575 95.375 100.675 77.4664 100.675 55.375C100.675 33.2836 82.7575 15.375 60.6546 15.375C38.5517 15.375 20.6338 33.2836 20.6338 55.375C20.6338 77.4664 38.5517 95.375 60.6546 95.375Z",
    fill: "url(#paint0_linear_407_8802)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1553 95.375C82.9819 95.375 100.676 77.6902 100.676 55.875C100.676 34.0598 82.9819 16.375 61.1553 16.375C39.3287 16.375 21.6348 34.0598 21.6348 55.875C21.6348 77.6902 39.3287 95.375 61.1553 95.375Z",
    stroke: "white",
    strokeOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6548 84.375C76.6794 84.375 89.6699 71.3913 89.6699 55.375C89.6699 39.3587 76.6794 26.375 60.6548 26.375C44.6302 26.375 31.6396 39.3587 31.6396 55.375C31.6396 71.3913 44.6302 84.375 60.6548 84.375Z",
    fill: "url(#paint1_linear_407_8802)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1539 80.375C74.2445 80.375 85.6672 68.9583 85.6672 54.875C85.6672 40.7917 74.2445 29.375 60.1539 29.375C46.0633 29.375 34.6406 40.7917 34.6406 54.875C34.6406 68.9583 46.0633 80.375 60.1539 80.375Z",
    fill: "url(#paint2_linear_407_8802)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1548 76.375C72.0351 76.375 81.6659 66.7491 81.6659 54.875C81.6659 43.0009 72.0351 33.375 60.1548 33.375C48.2744 33.375 38.6436 43.0009 38.6436 54.875C38.6436 66.7491 48.2744 76.375 60.1548 76.375Z",
    fill: "url(#paint3_linear_407_8802)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1546 71.375C69.7194 71.375 76.6626 64.4354 76.6626 55.875C76.6626 47.3146 69.7194 40.375 61.1546 40.375C52.5897 40.375 45.6465 47.3146 45.6465 55.875C45.6465 64.4354 52.5897 71.375 61.1546 71.375Z",
    fill: "url(#paint4_linear_407_8802)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_407_8802",
    x: -39.3662,
    y: -44.625,
    width: 200.542,
    height: 200.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_407_8802"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.494118 0 0 0 0 0.768627 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_407_8802",
    result: "effect2_dropShadow_407_8802"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_407_8802",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_8802",
    x1: 60.6546,
    y1: 15.375,
    x2: 60.6546,
    y2: 95.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_407_8802",
    x1: 60.6548,
    y1: 26.375,
    x2: 60.6548,
    y2: 84.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_407_8802",
    x1: 60.1539,
    y1: 29.375,
    x2: 60.1539,
    y2: 80.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_407_8802",
    x1: 60.1548,
    y1: 33.375,
    x2: 60.1548,
    y2: 76.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_407_8802",
    x1: 61.1546,
    y1: 40.375,
    x2: 61.1546,
    y2: 71.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.102
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.0fc364a36245c15de6d7a04cb2165fc7.svg";
export { ForwardRef as ReactComponent };